import React, { Fragment, memo, useState } from "react";

import { CourceVenue } from './CourceVenue';

export const CourceVenueList = memo((props) => {
  const { items } = props;

  return (
    <>
      <table className="table table-bordered table-hover table-condensed">
          <thead>
            <tr>
              <th style={{ width: 90 + 'px' }}>ID</th>
              <th style={{ width: 90 + 'px' }}>巡回会場ID</th>
              <th>巡回会場名</th>
              <th>日程</th>
              <th><i className="fas fa-filter" /> 操作</th>
            </tr>
        </thead>
        <tbody>
          {items.map(item =>
            <CourceVenue key={item.id} item={item} />
          )}
        </tbody>
      </table>
    </>
  );
});
